import React, { Component } from "react";
import Layout from "./../Layout/Layout";
import { Route, Switch } from "react-router-dom";
import Home from "./../Home/Home";
import Needs from "./../Needs/Needs";
import TresureHunt from "./../TresureHunt/TresureHunt";
import styles from "./Main.module.css";

class Main extends Component {
  state = {
    cart: 0,
    cartItems: [],
  };

  addToCartHandler = (item) => {
    let c = this.state.cart;
    let cI = [...this.state.cartItems];
    cI.push(item);
    this.setState({ cart: c + 1, cartItems: cI });
  };
  render() {
    return (
      <div className={styles.Main}>
        <Layout>
          <Switch>
            <Route path="/needs" component={Needs} />
            <Route
              path="/food"
              render={() => (
                <TresureHunt need="food" cart={this.addToCartHandler} />
              )}
            />
            <Route
              path="/medical"
              render={() => (
                <TresureHunt need="medical" cart={this.addToCartHandler} />
              )}
            />
            <Route
              path="/technical"
              render={() => (
                <TresureHunt need="engineer" cart={this.addToCartHandler} />
              )}
            />
            <Route
              path="/direction"
              render={() => (
                <TresureHunt need="direction" cart={this.addToCartHandler} />
              )}
            />
            <Route
              path="/"
              exact
              render={() => (
                <Home cart={this.state.cart} cartItems={this.state.cartItems} />
              )}
            />
          </Switch>
        </Layout>
      </div>
    );
  }
}

export default Main;
